import React, { useEffect, useMemo, useRef } from "react";
import { classNames } from "@ct-react/core";
import { Asset, Ratio } from "../../models/medias";
import "./ratio-images.scss";

type RatioImageProps = {
  className?: string;
  ratio?: Ratio;
  images: Asset[];
  alt: string;
  lazy?: boolean;
}

const RatioImage = (
  {
    className,
    ratio = Ratio.THREE_TWO,
    images,
    alt,
    lazy = true
  }: RatioImageProps) => {

  const imgRef = useRef<HTMLImageElement>(null);
  const [ visible, setVisible ] = React.useState(!lazy);

  const sm = useMemo(() => images.find(i => i.breakpoint === "SM"), [ images ]);
  const md = useMemo(() => images.find(i => i.breakpoint === "MD"), [ images ]);
  const lg = useMemo(() => images.find(i => i.breakpoint === "LG"), [ images ]);
  const full = useMemo(() => images.find(i => !i.breakpoint), [ images ]);

  useEffect(() => {
    if (!imgRef.current || !lazy) return;
    const observer = new IntersectionObserver((entries, obs) => entries.forEach((entry) => {
      if (!imgRef.current || !entry.isIntersecting) return;
      setVisible(true);
      obs.unobserve(imgRef.current);
    }));
    observer.observe(imgRef.current);
    return () => { observer.disconnect(); }
  }, []);
  const wrapperClasses = classNames("r-img", ratio, className);

  return (
    <picture className={wrapperClasses}>

      {!!sm && <source srcSet={sm.url} media="(max-width: 375px) " />}
      {!!md && <source srcSet={md.url} media="(max-width: 992px) "/>}
      <img ref={imgRef}
           src={visible ? lg?.url || full?.url || md?.url || sm?.url : ""}
           alt={alt} />
    </picture>
  );

};

export default RatioImage;
